import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
// Import UI Components
import ConfirmationModal from 'components/common/Modals/ConfirmationModal';
// Import Hooks
import useRequest from 'hooks/UseRequest';
import useCancelableRequests from 'hooks/UseCancelableRequests';
// Import Constants
import { ModalsActions, l, ActionsIcons, ModalsClassNames } from 'constants/common';
// Import Services
import { UtilsHttpService } from 'services/http';
import { createDeleteFilterTagDTO } from './service';

const ConfigureFilterTagActionsModals = ({
    filtersTagKey,
    isDeleteModalOpenedState,
    onCloseModalHandler,
    modalsStateSetDict,
    openedModalData,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const { doPostRequest } = useRequest();

    const { deleteFilterTagRequest } = useCancelableRequests({
        deleteFilterTagRequest: UtilsHttpService.deleteFiltersTagGroup,
    });

    const deleteFilterTag = () => {
        setIsLoading(true);

        doPostRequest(deleteFilterTagRequest.request, {
            requestBody: createDeleteFilterTagDTO(filtersTagKey, openedModalData),
            isShowError: false,
        }).then(({ AlertMessage, AlertType, IsCanceled }) => {
            // Aborted on unmount: do not close the modal or show a toaster
            if (IsCanceled) return;

            onCloseModalHandler(modalsStateSetDict.deleteFilterTag.key, ModalsActions.DELETE, AlertType, AlertMessage);
            setIsLoading(false);
        });
    };

    return isEmpty(openedModalData) ? null : (
        <>
            {isDeleteModalOpenedState && (
                <ConfirmationModal
                    onOk={deleteFilterTag}
                    onCancel={() => onCloseModalHandler(modalsStateSetDict.deleteFilterTag.key)}
                    isVisibleModal={isDeleteModalOpenedState}
                    titleText={t(l.DeleteFilterGroup)}
                    isLoading={isLoading}
                    iconType={ActionsIcons.Delete}
                    actionLabel={t(l.Delete)}
                    className={ModalsClassNames.Delete}
                    questionLabel={t(l.AreYouSureYouWantToDeleteFilterGroup, {
                        filterTagName: `"${openedModalData.Label}"`,
                    })}
                />
            )}
        </>
    );
};

ConfigureFilterTagActionsModals.propTypes = {
    filtersTagKey: PropTypes.string.isRequired,
    isDeleteModalOpenedState: PropTypes.bool.isRequired,
    onCloseModalHandler: PropTypes.func.isRequired,
    modalsStateSetDict: PropTypes.object.isRequired,
    openedModalData: PropTypes.any.isRequired,
};

export default memo(ConfigureFilterTagActionsModals);
